<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ deleteError }}</span>
    </div>
    <div
      v-if="item"
      class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Label</th>
            <td>{{ item['label'] }}</td>
          </tr>
          <tr>
            <th scope="row">Link</th>
            <td>{{ item['link'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      :to="{ name: 'InfoList' }"
      class="btn btn-primary">
      Back to list
    </router-link>
    <router-link
      v-if="item"
      :to="{ name: 'InfoUpdate', params: { id: item['@id'] } }"
      class="btn btn-warning">
      Edit
    </router-link>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import apiUrl from '../../store/modules/links/links';

export default {
  data() {
    return {
      imageUrl: apiUrl.API_HOST,
    }
  },
  computed: {
    ...mapFields('info/del', {
      deleteError: 'error',
    }),
    ...mapFields('info/show', {
      error: 'error',
      isLoading: 'isLoading',
      item: 'retrieved',
    }),
    ...mapFields('mediaobject/list', {
      'imageSelectItems': 'selectItems',
    }),        
  },
  beforeDestroy () {
    this.reset();
  },
  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id));
    this.imageGetSelectItems();
  },
  methods: {
    ...mapActions({
      reset: 'info/show/reset',
      retrieve: 'info/show/retrieve',
    }),
    ...mapActions({
        imageGetSelectItems: 'mediaobject/list/getSelectItems',
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/info/Show.vue